export const JobsInfo = [
    {
        JobTitle: "PHP Developer",
        JobLocation: "Hyderabad, India",
        Experiance: "4 Years",
        DateOfPosted: "2024-06-10",
        Location: "USA",
        JobType:"Remote",
        JobCategory:"Software Engineer",
        Description:
            "Analyze large datasets to derive insights and support decision-making.Build predictive models and machine learning algorithms.Communicate findings to stakeholders through data visualizations and reports.Work with engineering teams to implement data-driven solutions.Stay up-to-date with the latest advancements in data science and machine learning.Conduct A/B testing to evaluate the impact of changes.Develop data collection processes and data management systems.Collaborate with product and business teams to understand their data needs.",
        Apply: "https://company.com/apply/data-scientist",
        Package: "12 LPA"
    },
    {
        JobTitle: "UI Developer",
        JobLocation: "Hyderabad, India",
        Experiance: "5 Years",
        DateOfPosted: "2024-06-10",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description:
            "Lead the product development process from ideation to launch.Define product vision, strategy, and roadmap.Work closely with engineering, design, and marketing teams.Gather and prioritize product and customer requirements.Track and measure product performance against business goals.Identify and mitigate risks associated with product development.Develop pricing strategies and business models.Ensure alignment with company objectives and customer needs.",
        Apply: "https://company.com/apply/product-manager",
        Package: "10 LPA"
    },

    {
        JobTitle: "UI/UX Designer",
        JobLocation: "Hyderabad, India",
        Experiance: "4 Years",
        DateOfPosted: "2024-06-07",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description:
            "Design user interfaces and create a seamless user experience.Conduct user research and usability testing.Collaborate with developers to ensure design feasibility.Create wireframes, prototypes, and high-fidelity mockups.Stay updated with the latest design trends and tools.Advocate for the end-user in all design and development processes.Develop and maintain design documentation and guidelines.Work closely with product managers to align design with business goals."
        ,
        Apply: "https://company.com/apply/ui-ux-designer",
        Package: "11 LPA"
    },
    {
        JobTitle: "Software Developer",
        JobLocation: "Hyderabad, India",
        Experiance: "5 Years",
        DateOfPosted: "2024-06-10",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description:
            "Design, develop, and test software applications.Collaborate with cross-functional teams to deliver high-quality software solutions.Troubleshoot and debug issues in existing software applications.Stay updated with the latest software development trends and technologies.Participate in code reviews and provide feedback to peers.Follow best practices for software development and maintain code quality.Document software specifications and implementation details.Contribute to the continuous improvement of software development processes.",
        Apply: "https://company.com/apply/software-developer",
        Package: "13 LPA"
    },
    {
        JobTitle: "HR Manager",
        JobLocation: "Hyderabad, India",
        Experiance: "3 Years",
        DateOfPosted: "2024-06-05",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description:
            "Oversee recruitment and hiring processes.Develop and implement HR policies and procedures.Manage employee relations and conflict resolution.Conduct performance reviews and provide feedback.Ensure compliance with labor laws and regulations.Develop training and development programs.Handle employee benefits and compensation.Maintain employee records and HR documentation."
        ,
        Apply: "https://company.com/apply/hr-manager",
        Package: "8 LPA"
    },
    {
        JobTitle: "Network Engineer",
        JobLocation: "Hyderabad, India",
        Experiance: "4 Years",
        DateOfPosted: "2024-06-05",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description:
            "Design, implement, and manage network infrastructure.Monitor network performance and troubleshoot issues.Ensure network security and compliance.Work with vendors to procure network equipment.Document network configurations and procedures.Provide support for network-related issues.Optimize network performance and scalability.Stay updated with new networking technologies.",
        Apply: "https://company.com/apply/network-engineer",
        Package: "10 LPA"
    },
    {
        JobTitle: "Business Analyst",
        JobLocation: "Hyderabad, India",
        Experiance: "5 Years",
        DateOfPosted: "2024-06-03",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"Software Engineer",
        Description: "Gather and analyze business requirements from stakeholders.Translate business requirements into functional specifications.Work with development teams to ensure the successful implementation of requirements.Create and maintain documentation related to business processes and requirements.Conduct data analysis to identify trends and insights.Collaborate with project managers to define project scope and objectives.Assist in the development of project plans and timelines.Provide support and guidance to end-users during project implementation.",
        Apply: "https://company.com/apply/business-analyst",
        Package: "12 LPA"
    },
    {
        JobTitle: "Content Writer",
        JobLocation: "Hyderabad, India",
        Experiance: "3 Years",
        DateOfPosted: "2024-06-01",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"information technology",
        Description:
            "Create engaging and informative content for various platforms.Research industry-related topics.Edit and proofread content for accuracy and clarity.Collaborate with marketing and design teams.Optimize content for SEO.Stay updated with content trends and best practices.Manage content calendars and deadlines.Repurpose content for different formats and audiences."
        ,
        Apply: "https://company.com/apply/content-writer",
        Package: "7LPA"
    },
    {
        JobTitle: "Quality Assurance Engineer",
        JobLocation: "Hyderabad, India",
        Experiance: "3 Years",
        DateOfPosted: "2024-06-01",
        Location: "USA",
        JobType:"OnSite",
        JobCategory:"manufacturing & production",    
        Description:
            "Develop and execute test cases and test plans.Identify and report software defects.Ensure software quality through manual and automated testing.Collaborate with development teams to resolve issues.Create and maintain testing documentation.Stay updated with testing tools and methodologies.Participate in the continuous improvement of QA processes.Provide feedback on product quality and usability.",
        Apply: "https://company.com/apply/qa-engineer",
        Package: "6 LPA"
    }
];



